module.exports = __webpack_public_path__ + "img/dongji_ps_20.652f29a2.jpg";